import { IRoleInitialValues } from '../types/permission';

export const initialValues: IRoleInitialValues = {
  name_en: '',
  name_ar: '',
  description_en: '',
  description_ar: '',
  permissions: [],
};
